import { Button } from '@cokitchen/cokitchen-components';
import LocalModal from 'components/base/local-modal';
import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as CheckmarkIcon } from 'assets/icons/greencheck.svg';
import { ROUTE_KEYS } from 'utils/constants';
import useOrdersContext from 'contexts/orders.context';

interface UpdateOrderSuccessModalProps {
  show: boolean;
  onClose: () => void;
}

const UpdateOrderSuccessModal: FC<UpdateOrderSuccessModalProps> = ({ show, onClose }) => {
  const navigate = useNavigate();
  const { handleReset } = useOrdersContext();

  const backToOrders = () => {
    handleReset();
    navigate(`/${ROUTE_KEYS.ORDERS}`);
  };

  return (
    <LocalModal
      isOpen={show}
      description={``}
      titleIconColor='success'
      onRequestClose={() => onClose()}>
      <div className='flex flex-col justify-center items-center'>
        <CheckmarkIcon />
        <p className='font-semibold text-[18px] mt-3'>Your order has been successfully updated</p>
      </div>
      <div className='mt-8'>
        <Button
          small
          color='primary'
          variant='block'
          className='w-[200px] ml-[130px]'
          onClick={backToOrders}>
          Back to Orders
        </Button>
      </div>
    </LocalModal>
  );
};

export default UpdateOrderSuccessModal;
